import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

import logo from "assets/img/sureqoute2.png";
import { Click } from "reducers/LoginReducer";
import store from "../store";
import { Logout } from "helpers/UserHelper";

import NotificationWrapper from "./hoc/NotificationWrapper";

const CLICK = "sure-quote/Login/CLICK";

const switchRoutes = scrollMethod => {
  if (!localStorage.getItem("token") && store.getState().login.token === "") {
    Logout();
    return <Redirect to="/app/portal/login" />;
  } else {
    return (
      <Switch>
        {dashboardRoutes.map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          if (prop.collapse)
            return prop.views.map((prop, key) => {
              let Component = prop.component;
              return (
                <Route
                  path={prop.path}
                  key={key}
                  render={props => (
                    <Component {...props} scrollMeBar={scrollMethod} />
                  )}
                />
              );
            });
          let Component = prop.component;
          return (
            <Route
              path={prop.path}
              key={key}
              render={props => (
                <Component {...props} scrollMeBar={scrollMethod} />
              )}
            />
          );
        })}
      </Switch>
    );
  }
};

var ps;

class Dashboard extends React.Component {
  state = {
    mobileOpen: false,
    miniActive: false,
    cookieTimeout: false
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }

    store.dispatch(Click({ type: CLICK, props: localStorage }));

    var hours = 4; // Reset when storage is more than 24hours
    var now = new Date().getTime();
    var setupTime = localStorage.getItem("setupTime");
    if (setupTime == null) {
      localStorage.setItem("setupTime", now);
    } else {
      if (now - setupTime > hours * 60 * 60 * 1000) {
        Logout();
        localStorage.setItem("setupTime", now);
        this.setState({ cookieTimeout: false });
      }
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }

  scrollMeBar = () => {
    if (ps) {
      this.refs.mainPanel.scrollTop = 0;
      ps.update();
    }
  }

  render() {
    if (this.state.cookieTimeout) {
      this.setState({ cookieTimeout: false });
      return <Redirect to="/app/portal/login" />;
    }

    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " mainPanelYes " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <NotificationWrapper>
        <div className={classes.wrapper}>
          <Sidebar
            routes={dashboardRoutes}
            logoText={"Creative Tim"}
            logo={logo}
            handleDrawerToggle={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            color="deepPurple"
            bgColor="black"
            miniActive={this.state.miniActive}
            {...rest}
          />
          <div className={mainPanel} ref="mainPanel">
            <Header
              logo={logo}
              logoText={"SureQuote"}
              sidebarMinimize={this.sidebarMinimize.bind(this)}
              miniActive={this.state.miniActive}
              routes={dashboardRoutes}
              handleDrawerToggle={this.handleDrawerToggle}
              {...rest}
            />
            {this.getRoute() ? (
              <div className={classes.content}>
                <div className={classes.container}>
                  {switchRoutes(this.scrollMeBar)}
                </div>
              </div>
            ) : (
              <div className={classes.map}>
                {switchRoutes(this.scrollMeBar)}
              </div>
            )}
            {this.getRoute() ? <Footer fluid /> : null}
          </div>
        </div>
      </NotificationWrapper>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard.jsx